const WEB_APP_URL_DOMAIN = String(import.meta.env.VITE_WEB_APP_URL_DOMAIN)?.replace(/^https?:\/\//, '')

const intentLinkWithCustomPath = (path = '') => {
  return `intent://${WEB_APP_URL_DOMAIN}${path}#Intent;scheme=emissaryai;package=com.emissary.android;end`
}

export const redirectToApp = (comesFromPlatform: string, token?: string | null): void => {
  const path = token ? `/redirect/?token=${token}` : '/logout-redirect/'
  if (comesFromPlatform === 'ios') {
    // structure of the link is: emissaryai://<domain>/<path>?<query>
    window.location.replace(`emissaryai://${WEB_APP_URL_DOMAIN}${path}`)
    // window.location.replace(`emissaryai://${path}`)
  } else if (comesFromPlatform === 'android') {
    window.location.replace(intentLinkWithCustomPath(path))
  }
}
